import {PROD_API_URL} from "../../constants/constants";

export const TASK_ITEM_LIST = [
    { value: 'quiz', label: 'Quiz', collection: 'quiz' },
    { value: 'username', label: 'Username', collection: 'cadets' },
    { value: 'profileImage', label: 'Profile Image', collection: 'cadets' },
    { value: 'email', label: 'Email', collection: 'cadets' },
    { value: 'discordUsername', label: 'Discord', collection: 'cadets' },
    { value: 'telegramUsername', label: 'Telegram', collection: 'cadets' },
    { value: 'twitterUsername', label: 'Twitter', collection: 'cadets' },
    { value: 'hasVaultAccount', label: 'Created Vault Account', collection: 'cadets' },
    { value: 'hasIdoAccount', label: 'Created IDO Account', collection: 'cadets' },
    { value: 'hasNodeIdoAccount', label: 'Created Node IDO Account', collection: 'cadets' },
    { value: 'twitterLikes', label: 'Like Specific Tweet', collection: 'twitter' },
    { value: 'twitterRepost', label: 'Re-post Specific Tweet', collection: 'twitter' },
    { value: 'twitterComment', label: 'Comment on Specific Tweet', collection: 'twitter' },
    { value: 'twitterFollow', label: 'Follow Specific Twitter Account', collection: 'twitter' },
    { value: 'status', label: 'KYC Status', collection: 'identities' },
    { value: 'starsSwapped', label: 'Total Stars Swapped', collection: 'tokenSwaps', supportsRange: true },
    { value: 'totalStaked', label: 'Staked Stars', collection: 'vaults', supportsRange: true  },
    { value: 'totalVaults', label: 'Total Number of Vaults', collection: 'vaults', supportsRange: true  },
    { value: 'total1Staked', label: 'Tot. 360days Staked Stars', collection: 'vaults', supportsRange: true  },
    { value: 'total2Staked', label: 'Tot. 180days Staked Stars', collection: 'vaults', supportsRange: true  },
    { value: 'total3Staked', label: 'Tot. 90days Staked Stars', collection: 'vaults', supportsRange: true  },
    { value: 'totalRaffleParticipated', label: 'Number of Raffles Participated', collection: 'cadetParticipations', supportsRange: true  },
    { value: 'totalRaffleTicketsPurchased', label: 'Number of Raffle Tickets purchased', collection: 'cadetParticipations', supportsRange: true  },
    { value: 'totalSalesParticipated', label: 'Sales/IDOs Participated in', collection: 'cadetParticipations', supportsRange: true  },
    { value: 'totalContributedStars', label: 'Total STARS Burnt', collection: 'cadetParticipations', supportsRange: true  },

]

export const TASK_ACTIONS_LIST = [
    { value: 'hasValue', label: 'Has Value' },
    { value: 'equals', label: 'Equals' },
    { value: 'contains', label: 'Contains' },
    { value: 'greaterThan', label: 'Greater Than' },
    { value: 'lessThan', label: 'Less Than' },
]